export const TOUCH_DELAY_MS = 700;
export const NO_DELAY_MS = 0;
export const LEAVE_TOUCH_DELAY_MS = 1500;
export const LONG_LEAVE_TOUCH_DELAY_MS = 60_000;
